<p class="font-bold line-height-2" i18n>
  PUK (Pin Unblocking Key) is the code required to reset the PIN. It's recommended to assign a PUK to each PIN.
</p>

<p class="font-bold line-height-2" i18n>The follow table contains the recommended settings. Please update as needed.</p>

<div class="mx-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />

  <p-table
    [value]="profileValues.pins"
    dataKey="id"
    sortField="type"
    [sortOrder]="1"
    styleClass="p-datatable-striped p-datatable-gridlines"
    showGridlines="true"
    stripedRows="true"
    [filters]="filterPinTypes"
  >
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 8rem" />
        <col style="width: 8rem" />
        <col style="width: 8rem" />
        <col />
        <col style="width: 10rem" />
        <col style="width: 10rem" />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th i18n>PUK #</th>
        <th i18n>PIN to Unblock</th>
        <th>
          <div i18n>PUK Size</div>
          <div class="font-medium" i18n>(4 to 8 digits)</div>
        </th>
        <th i18n>Value</th>
        <th>
          <div i18n>Max Attempts</div>
          <div class="font-medium" i18n>(0 to 15)</div>
        </th>
        <th>
          <div i18n>Retries Left</div>
          <div class="font-medium" i18n>(0 to 15)</div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pin>
      <tr>
        <td class="text-center">
          <ng-container *ngIf="+pin.type === 1">PUK{{ pin.number }}</ng-container>
          <ng-container *ngIf="+pin.type === 2">PUK{{ +pin.number + 8 }}</ng-container>
        </td>
        <td class="text-center">
          <ng-container *ngIf="+pin.type === 1">PIN{{ pin.number }}</ng-container>
          <ng-container *ngIf="+pin.type === 2">LOCALPIN{{ pin.number }}</ng-container>
        </td>
        <td class="text-center">
          <p-inputNumber
            class="maximize-inputs"
            inputStyleClass="maximize-inputs centered-inputs"
            [(ngModel)]="pin.puk.size"
            mode="decimal"
            [showButtons]="false"
            (onBlur)="handleFormEvents()"
          ></p-inputNumber>
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <p-radioButton
              (onClick)="handleFormEvents()"
              name="pin.puk.valueGeneration"
              [inputId]="'pin[' + pin.id + '].puk.valueGeneration#1'"
              value="1"
              [(ngModel)]="pin.puk.valueGeneration"
            ></p-radioButton>
            <label class="mr-3 label-clickable nobr" [for]="'pin[' + pin.id + '].puk.valueGeneration#1'" i18n>eDGAR Generated</label>
            <p-radioButton
              (onClick)="handleFormEvents()"
              name="pin.puk.valueGeneration"
              [inputId]="'pin[' + pin.id + '].puk.valueGeneration#2'"
              value="2"
              [(ngModel)]="pin.puk.valueGeneration"
            ></p-radioButton>
            <label class="label-clickable nobr" [for]="'pin[' + pin.id + '].puk.valueGeneration#2'" i18n>User Defined</label>
          </div>
          <input
            *ngIf="+pin.puk.valueGeneration === 2"
            pInputText
            rsNumbersOnlyInput
            class="maximize-inputs console-text mt-3"
            [maxlength]="pin.puk.size"
            [(ngModel)]="pin.puk.value"
            (input)="handleFormEvents()"
            (focus)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)"
            (blur)="clearDynamicToast()"
          />
        </td>
        <td class="text-center">
          <p-inputNumber
            class="maximize-inputs"
            inputStyleClass="maximize-inputs centered-inputs"
            [(ngModel)]="pin.puk.maxAttempts"
            mode="decimal"
            [showButtons]="false"
            (onBlur)="handleFormEvents()"
          ></p-inputNumber>
        </td>
        <td class="text-center">
          <p-inputNumber
            class="maximize-inputs"
            inputStyleClass="maximize-inputs centered-inputs"
            [(ngModel)]="pin.puk.retryNumberLeft"
            mode="decimal"
            [showButtons]="false"
            (onBlur)="handleFormEvents()"
          ></p-inputNumber>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
